import Spinner from 'react-bootstrap/Spinner'

const LoaderSpinner = () => {
  return <Spinner animation='border' variant='warning' />
}

export default LoaderSpinner
